import { memo } from "react";
import { Route, RouteProps, Routes } from "react-router-dom";

const RoutesLayout = memo(({ routes }: { routes: RouteProps[] }) => {
  return (
    <Routes>
      {routes.map((route: RouteProps) => {
        return <Route key={route.path} path={route.path} Component={route.Component} />;
      })}
    </Routes>
  );
});

export default RoutesLayout;
